export default "__VITE_ASSET__BG$MBLRy__"